(function () {
  'use strict';

  // ── Card float button positioning ────────────────────────────────────────
  function positionOneButton(floatEl) {
    var wrapper = floatEl.closest('.card-wrapper');
    if (!wrapper) return;
    var inner = wrapper.querySelector('.card__inner');
    if (!inner) return;
    var wrapperRect = wrapper.getBoundingClientRect();
    var innerRect = inner.getBoundingClientRect();
    if (innerRect.height === 0) return;
    var bottomOffset = wrapperRect.bottom - innerRect.bottom + 12;
    floatEl.style.bottom = (bottomOffset < 12 ? 12 : bottomOffset) + 'px';
  }

  function positionButtons() {
    document.querySelectorAll('.card__quick-add-float').forEach(positionOneButton);
  }

  // IntersectionObserver: reposition when card scrolls near the viewport
  var floatIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) positionOneButton(entry.target);
    });
  }, { rootMargin: '300px 0px' });

  function observeFloatButton(el) {
    floatIO.observe(el);
  }

  function observeFloatButtons() {
    document.querySelectorAll('.card__quick-add-float').forEach(observeFloatButton);
  }

  // MutationObserver: catch cards injected dynamically by <product-recommendations> AJAX
  var cardMutObs = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.classList && node.classList.contains('card__quick-add-float')) {
          observeFloatButton(node);
        } else {
          node.querySelectorAll('.card__quick-add-float').forEach(observeFloatButton);
        }
      });
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      positionButtons();
      observeFloatButtons();
      cardMutObs.observe(document.body, { childList: true, subtree: true });
    });
  } else {
    positionButtons();
    observeFloatButtons();
    cardMutObs.observe(document.body, { childList: true, subtree: true });
  }
  window.addEventListener('load', positionButtons);
  window.addEventListener('resize', positionButtons);

  // ── Success animation ────────────────────────────────────────────────────
  var CHECK_SVG = '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"'
    + ' width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"'
    + ' stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">'
    + '<polyline points="20 6 9 17 4 12"/></svg>';

  function showSuccess(btn) {
    var iconSpan = btn.querySelector('span:first-child');
    if (!iconSpan) return;
    var original = iconSpan.innerHTML;
    iconSpan.innerHTML = CHECK_SVG;
    btn.classList.add('qaf--success');
    setTimeout(function () {
      btn.classList.remove('qaf--success');
      iconSpan.innerHTML = original;
    }, 1600);
  }

  // ── Pubsub: success animation after cart add ─────────────────────────────
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
      if (!data || data.source !== 'product-form') return;
      var variantId = String(data.productVariantId);
      var cardInput = document.querySelector(
        '.card__quick-add-float [name="id"][value="' + variantId + '"]'
      );
      if (!cardInput) return;
      var pf = cardInput.closest('product-form');
      if (!pf) return;
      var cardBtn = pf.querySelector('.card__quick-add-btn');
      if (cardBtn) showSuccess(cardBtn);
    });
  }
})();
